import { useDropzone } from "react-dropzone";
import Papa from "papaparse";
import React, { useCallback, useState, useEffect } from "react";

function UploadCSV({ setSizeData, setAutoSequence, sizes, setIncludeNames }) {
    const [file, setFile] = useState(null);
    const [csvData, setCSVData] = useState(null);
    const [error, setError] = useState(false);

    const onDrop = useCallback((acceptedFiles) => {
        setError(false);
        const reader = new FileReader();
        reader.onload = () => {
            try {
                const result = reader.result;
                const data = Papa.parse(result, { header: true });
                console.log(data, sizes)

                //make sure its ends in a .csv
                if (!acceptedFiles[0].name.endsWith('.csv')) {
                    setError('File must be a CSV')
                    return;
                }

                
                
                //change the names to be 'name' 'number' and 'size' use a filter to search for matching headers as they may not be standard
                const headers = data.meta.fields;

                const nameHeaders = headers.filter((header) => header.toLowerCase().includes('name'));
                const numberHeaders = headers.filter((header) => header.toLowerCase().includes('number'));
                const sizeHeaders = headers.filter((header) => header.toLowerCase().includes('size'));

                //make sure we atleast have sizes
                if (sizeHeaders.length === 0) {
                    setError('CSV must have a size column')
                    return;
                }

                data.data = data.data.map((row) => {
                    return {
                        Name: row[nameHeaders[0]],
                        Number: row[numberHeaders[0]],
                        Size: row[sizeHeaders[0]]
                    }
                });

                setCSVData(data.data);
                alert('CSV uploaded successfully')
                //move the windot down to the next .totals div
                window.scrollTo(0, document.querySelector('.totals').offsetTop);
            } catch (error) {

                setError(error.message)
                window.scrollTo(0, document.querySelector('.error').offsetTop);


            }


            // setCSVData(data);
        };
        reader.readAsText(acceptedFiles[0]);
        setFile(acceptedFiles[0]);
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: ".csv",
    });

    useEffect(() => {
        if (csvData) {
            console.log(csvData, 'csvData');
            // setIncludeNames(true)
            // setAutoSequence(false)

            const newSizeData = sizes.map((size) => {
                console.log(size, 'size');
                const sizeData = csvData.filter((row) => row.Size.toLowerCase() === size.toString().toLowerCase());
                return {
                    size: size,
                    qty: sizeData.length,
                    sizeNumbers: sizeData.map((row) => row.Number),
                    sizeNames: sizeData.map((row) => `${row.Name}`)
                };
            })

            const hasNames = csvData.some((row) => row.Name);
            if (hasNames) {
                setIncludeNames(true)
            }
            setAutoSequence(false)

            console.log(hasNames, 'hasNames');

            setSizeData(newSizeData)
        }
    }, [csvData]);



    return (
        <>
            {
                error && < div className="Error">
                    {error && <p>{error}</p>}
                </div>
            }
            <div className="drop-zone" {...getRootProps()}>
                <input {...getInputProps()} />
                {isDragActive ? (
                    <p>Drop the file here ...</p>
                ) : (
                    <p>Drag 'n' drop the file here, or click to select file</p>
                )}
            </div>
        </>

    );
}
export default UploadCSV;

